import { render, staticRenderFns } from "./ListLocation.vue?vue&type=template&id=020fa3ed&"
import script from "./ListLocation.vue?vue&type=script&lang=js&"
export * from "./ListLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports